// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1cfdfae8","455":"33a5a10f","977":"7f4f90c6"}[chunkId] + ".chunk.js";
};